import { Component, ViewChild} from '@angular/core';
import { GlobalService } from '../global.service';
import { CignalService } from '../cignal.service';
import { Router } from '@angular/router';
import {Sort} from '@angular/material/sort';
import { FilterSearchBarComponent } from '../reusables/filter-search-bar/filter-search-bar.component';
import { TpUsernameFilterComponent } from '../reusables/tp-username-filter/tp-username-filter.component';
import { DateRangePickerComponent } from '../reusables/date-range-picker/date-range-picker.component';
import { MobileTableSortComponent } from '../reusables/mobile-table-sort/mobile-table-sort.component';
import { SellInService } from '../services/sell-in/sell-in.service';

@Component({
  selector: 'app-sell-in',
  templateUrl: './sell-in.component.html',
  styleUrls: ['./sell-in.component.css'],
})
export class SellInComponent {

  @ViewChild(FilterSearchBarComponent) 
  private SearchBar!:FilterSearchBarComponent;
  @ViewChild(TpUsernameFilterComponent) 
  private tpUsernameFilter!:TpUsernameFilterComponent;
  @ViewChild(DateRangePickerComponent) 
  private dateRangePicker!:DateRangePickerComponent;
  @ViewChild(MobileTableSortComponent) 
  private mobileTableSortComponent!:MobileTableSortComponent;

  constructor(
    private cignalService: CignalService,
    public globalService: GlobalService,
    private router: Router,
    private sellInService: SellInService
  ){}
  isMobile : boolean = false;
  sellInData : Array<any>= [];
  currentTab = "tp";
  requestId = 0;
  requestTotalId = 0;

  requestParam:any = {};
  itemsPerPage:number = 15;

  isLoading : boolean = false;
  message : any;

  sort_by : string = ""
  sort_order : string = ""
  


  ngOnInit(){
    this.isMobile = this.globalService.isMobile();
    this.requestParam.limit = this.itemsPerPage;
    this.requestParam.criteria = {};
    this.getSellInData();
  }

  updateSortMenuItem(){
    switch (this.currentTab) {
      case 'tp':
        return [
          ['Territorial Partner','tp_username'],
          ['e-Pins Denoms','code'],
          ['Amount','amount'],
          ['Date','create_date'],
        ];

      case 'dealer':
        return [
          ['Dealer','dealer_username'],
          ['Territorial Partner','tp_username'],
          ['e-Pins Denoms','code'],
          ['Amount','amount'],
          ['Date','create_date'],
        ];
      
      case 'retailer':
        return [
          ['Retailer','retailer_username'],
          ['Dealer/Territorial Partner','tp_dealer_username'],
          ['e-Pins Denoms','code'],
          ['Amount','amount'],
          ['Date','create_date'],
        ];
        
      default:
        return [];

    }
  }

  // PAGINATION
  current_page = 1;
  total_page = 1;
  updateSellInRecordPage(page:number){
    this.current_page = page;
    this.requestParam.offset = (this.current_page-1) * this.itemsPerPage;
    this.getSellInData();
  }

  // SEARCH FILTER
  searchValue:string = "";
  updateSearchValue(keyWord:string){
    this.current_page = 1;
    this.requestParam.search_term = keyWord;
    this.searchValue = keyWord;
    this.getSellInData();
  }

  // SELL-IN FILTER
  sellInFilter : any = {};
  
  // TP NAME FILTER
  updateTpNameFilter(newTpName:string){
    this.requestParam.criteria.tp = newTpName.trim();
    this.current_page = 1;
    this.getSellInData();
  }
  
  // DATE RANGE FILTER
  updateDateRangeFilter(newDateRangeFilter:any){
    this.clearSearch();
    delete this.requestParam.criteria.from_date;
    delete this.requestParam.criteria.to_date;

    if (typeof newDateRangeFilter.start_date === 'object') {
      this.requestParam.criteria.from_date = this.globalService.formatNgbDateStructToString(newDateRangeFilter.start_date);      
    }
    if (typeof newDateRangeFilter.end_date === 'object') {
      this.requestParam.criteria.to_date = this.globalService.addOneDayToEndDate(newDateRangeFilter.end_date);      
    }
    this.current_page = 1;
    this.getSellInData();
  }

  
  showFilter(val:boolean){
    let sidebar = document.getElementById("filter_div") as HTMLElement;
    if (sidebar) {
      var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      if (width < 600) {
        if (val) {
          sidebar.style.display = "flex";
        }else{
          sidebar.style.display = "none";
        } 
      }
    }
  }

  formatFilterJson(filterJson : any, limit : number, offset: number,sort_by: string,sort_order:string){
    var filter : any = {};
    if (filterJson.tpNameFilter) { 
      filter.tp_username = filterJson.tpNameFilter;
    }
    if (filterJson.end_date) { 
      filter.to_date = filterJson.end_date;
    }
    if (filterJson.start_date) {
      filter.from_date = filterJson.start_date;
    }
    if (sort_order && sort_by) {
      filter.sort_order = sort_order;
      filter.sort_by = sort_by;
    }
    
    
    filter.limit = limit;
    filter.offset = offset;

    return filter;
  }

  // Clear
  clearFilters(){
    this.tpUsernameFilter.clearTpNameFilter();
    this.dateRangePicker.clearDateRange();
    this.requestParam.criteria = {};
  }
  clearSearch(){
    this.searchValue = "";
    this.SearchBar.clearSearch();
    delete this.requestParam.search_term;
  }
  clearAllFilters(){
    this.clearSearch();
    this.clearFilters();
    this.current_page = 1;
    this.getSellInData();
  }

  // Sort
  updateSort(sort:Sort){
    if (sort.direction) {
      this.requestParam.sort_order = sort.direction;
      this.requestParam.sort_by = sort.active;
    }else{
      this.requestParam.sort_order = "";
      this.requestParam.sort_by = "";
    }
    this.getSellInData();
  }

  // Export
  async exportSellInRecord(){
  this.message = "";

    var result = await this.cignalService.exportSellInData(this.requestParam, this.currentTab);

    if (result) {
      if (result.success) {

        this.globalService.showSnackbar(result.message,"Ok");
        this.router.navigateByUrl("/exports");
      
      }else{
        console.log(result.message);
        this.message = result.message;
      }
    }
  }

  // Select Tab
  selectTab(tabName:string){
      
    if (this.currentTab != tabName) {
      if (this.isMobile) {
        this.mobileTableSortComponent.clearSort();
      }
      this.current_page = 1;
      this.total_page = 1;
      this.currentTab = tabName;
      delete this.requestParam.offset;
      this.clearFilters();
      this.updateSort({direction:'', active:''});
    }
  }

  // Get and Display Data
  async getSellInData(){
    this.isLoading = true;
    this.message = '';
    this.sellInData = [];

    this.requestId += 1;

    var requestId = this.requestId;
    var result = null;
    console.log(this.requestParam);
    // switch (this.currentTab) {
    //   case 'wallet':
        result = await this.sellInService.getSellInRecord(this.currentTab, this.requestParam);
    //     break;
      
    //   case 'dealer':
    //     result = await this.sellInService.getSellInRecord(this.currentTab, this.requestParam);
    //     break;

    //   case 'subdealer':
    //     result = await this.sellInService.getSellInRecord(this.currentTab, this.requestParam);
    //     break;
      
    //   case 'retailer':
    //     result = await this.sellInService.getSellInRecord(this.currentTab, this.requestParam);

    //     break;
    //   default:
    //     break;
      
    // }
    this.mountData(result, requestId);
  }

  mountData(result: any, requestId: number){
    if (this.requestId == requestId) {
      if(result){
        if (result.message) {
          this.message = result.message;
        }else{
          this.sellInData = result.items;
          console.log(this.sellInData);
          this.total_page = Math.ceil(result.total / this.itemsPerPage);
        }
      }
      
    if (this.sellInData.length == 0 && !this.message) {
      this.message = 'No item available.'
    }
    
      this.isLoading = false;
      
    }
  }


}
